import script from "./CardPayForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPayForm.vue?vue&type=script&setup=true&lang=js"

import "./CardPayForm.vue?vue&type=style&index=0&id=bdd837f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdd837f8"]])

export default __exports__